import { AccountDetail } from '@repo/accounts-types'
import { ApiResponse, GenericOperationState } from '@repo/core'
import { RootState } from '../../../store/types'

export const accountDetailDataSelectorConfig = {
  accountDetailDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<AccountDetail> | null> {
      return state.accounts.detail.read.data
    },
  },
  accountDetailDownloadSelector: {
    getRootPath: (state: RootState) => state.accounts.detail.read.download,
  },
}
